import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useHealth } from '../hooks/useApi'
import { useAuth } from '../contexts/AuthContext'

export default function Navbar() {
  const { data: health } = useHealth()
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  const handleLogout = async () => {
    if (isLoggingOut) return

    try {
      setIsLoggingOut(true)
      await logout()
      navigate('/login')
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      setIsLoggingOut(false)
    }
  }

  const getRoleBadge = () => {
    if (!user) return null

    if (user.role === 'admin') {
      return <span className="badge bg-danger ms-2">管理者</span>
    }

    return <span className="badge bg-warning text-dark ms-2">パワーユーザー</span>
  }

  const getPermissionsText = () => {
    if (!user || user.role === 'admin' || !user.permissions || user.permissions.length === 0) {
      return null
    }

    const permCount = user.permissions.length
    return (
      <small className="text-muted ms-2" style={{ fontSize: '0.75rem' }}>
        ({permCount} 権限)
      </small>
    )
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-dark">
      <div className="container">
        <span className="navbar-brand">
          <i className="fas fa-broadcast-tower me-2" />
          マゴスピーカーモニタリング
        </span>

        <div className="navbar-nav ms-auto d-flex flex-row align-items-center gap-3">
          {user && (
            <div className="navbar-text d-flex align-items-center">
              <i className="fas fa-user me-2" />
              <span className="fw-bold">{user.username}</span>
              {getRoleBadge()}
              {getPermissionsText()}
            </div>
          )}

          <span className="navbar-text">
            <i
              className={`fas fa-circle me-1 ${health?.status === 'healthy' ? 'text-success' : 'text-danger'}`}
            />
            <span>{health?.status === 'healthy' ? '接続済み' : '切断'}</span>
          </span>

          {user && (
            <button
              className="btn btn-outline-light btn-sm"
              onClick={handleLogout}
              disabled={isLoggingOut}
              type="button"
            >
              {isLoggingOut ? (
                <>
                  <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                  ログアウト中...
                </>
              ) : (
                <>
                  <i className="fas fa-sign-out-alt me-1" />
                  ログアウト
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </nav>
  )
}
